import React, { useEffect } from "react";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { ReactComponent as Unchecked } from "../../assets/analyse/Unchecked.svg";
import { ReactComponent as Reducearrow } from "../../assets/analyse/proposition_arrow.svg";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as RecipeImg } from "../../assets/analyse/AnalyseRecipe.svg";
import { ReactComponent as DeliveryIcon } from "../../assets/analyse/DeliveryIcon.svg";
import { ReactComponent as ConsumptionIcon } from "../../assets/analyse/consumption.svg";
import { ReactComponent as RetailIcon } from "../../assets/analyse/retail.svg";
import { ReactComponent as DistributionIcon } from "../../assets/analyse/distribution.svg";
import AnalysisLine from "./AnalysisLine";
import { useState } from "react";
import { green } from "@mui/material/colors";
import ReduceAnalysisLine from "./ReduceAnalysisLine";
import ReduceAnalysisLineRight from "./ReduceAnalysisLineRight";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const ReduceSubstepRight = ({ name, icon, data, width, quantity, quantityUnit, columns, hidden, flow_id, line_index, step, totalScore, ingredient_id, ingredients, depth, is_ingredient }) => {
  // const [hide, setHide] = useState("");
  const hiddenindex = step + depth * 5;
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));
  const optimization_data = useSelector((state) => state.optimization.optimization_data, shallowEqual);

  // width -= 30;

  const impact_factors = data.custom_analysis.flow.flow_impact_factors;
  // const quantity = data.optimization_results.amount;
  // const quantityUnit = data.custom_analysis.unit.name;
  const conversion_factor = data.custom_analysis.unit.conversion_factor;
  const checked = data.custom_analysis.checked;

  const get_impact_optimization = (indicator_id, analysis_data) => {
    let transports_impact = 0;
    // let indicator_unit;
    if (step === 2) {
      //////////// get receip impact
      if (!analysis_data.ingredients[flow_id].name) {
        // if ingredients

        // get transports categories
        const transports_data = Object.values(analysis_data.ingredients[flow_id]).find((x) => x.category.name === "K_Transports");
        // console.log("transports_data", transports_data);

        if (transports_data && transports_data.inputs) {
          // filter optimization
          const opt_inputs = Object.values(transports_data.inputs).filter((x) => x.optimization_results);
          // console.log("opt_inputs", opt_inputs);

          transports_impact =
            transports_impact +
            Object.values(opt_inputs).reduce((accumulator, currentValue) => {
              const indicator = currentValue.optimization_results.flow.flow_impact_factors.find((i) => i.id === indicator_id);
              const indicator_coefficient = indicator ? indicator.coefficient : 0;
              const amount = currentValue.optimization_results.amount;
              const conversion_factor = currentValue.optimization_results.unit.conversion_factor;
              return accumulator + indicator_coefficient * amount * conversion_factor;
            }, 0);

          // console.log('transports_impact', transports_impact)

          const nomal_inputs = Object.values(transports_data.inputs).filter((x) => !x.optimization_results);
          const transports_data_inputs = Object.values(nomal_inputs).filter((x) => x.flow.category.name === "K_Transports");
          transports_impact =
            transports_impact +
            Object.values(transports_data_inputs).reduce((accumulator, currentValue) => {
              const indicator = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id);
              const indicator_coefficient = indicator ? indicator.coefficient : 0;
              const amount = currentValue.amount;
              const conversion_factor = currentValue.unit.conversion_factor;
              return accumulator + indicator_coefficient * amount * conversion_factor;
            }, 0);
        }

        // console.log('transports_impact', transports_impact)

        // //////////// get ingredient impact
        const ingredient = Object.values(Object.values(analysis_data.lca.lca_steps)[6 - step].inputs)[line_index];
        const ingredient_indicator = ingredient.flow.flow_impact_factors.find((i) => i.id === indicator_id);
        const ingredient_impact = ingredient_indicator ? ingredient.amount * ingredient.unit.conversion_factor * ingredient_indicator.coefficient : 0;
        transports_impact = transports_impact + ingredient_impact;

        // console.log('transports_impact', transports_impact)
      } else {
        transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
      }
    } else {
      transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
    }

    return transports_impact;
  };

  const [impactt, setImpactt] = useState(null);

  useEffect(() => {
    const calc_fn = async () => {
      setImpactt((get_impact_optimization("da32f256-618d-4bec-a8d9-205817788b26", optimization_data) / totalScore) * 100);
    };
    calc_fn();
  });

  return (
    <>
      <div>
        <div className={`h-[40px] bg-white border-[0.1px] boder-[#F3F5F7] flex w-max`}>
          {/* QUANTITY */}

          {is_ingredient ? (
            <>
              <div
                key={"reducesubstepright" + Math.random() + "quantity"}
                className={"flex grid grid-cols-[70px_40px] justify-center items-center h-[40px] w-[140px] border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular"}
              >
                <div>
                  <input
                    disabled={true}
                    type="number"
                    className="w-[60px] bg-transparent text-right flex mr-1"
                    // onChange={(event) => handleOnChangeQuantity(event, quantity)}
                    value={quantity}
                    onWheel={(e) => e.target.blur()}
                  />{" "}
                </div>
                <div>{quantityUnit}</div>
              </div>

              <div
                key={"reducesubstepright" + Math.random() + "impact_percent"}
                className={`flex justify-evenly items-center h-[40px]  w-[140px]  border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}
              >
                <div className="h-[40px] w-[54.5px] flex justify-end items-center">
                  <p className="mr-[10px]">{impactt && impactt.toFixed(2)}</p>
                </div>
                <div className="w-[60px] h-[5px] bg-[#BEC4CA]/50 rounded-xl mr-[5px] flex justify-start">
                  <div style={{ width: impactt }} className={`w-[${impactt}%] h-[5px] rounded-xl bg-[#BEC4CA]`} />
                </div>
              </div>

              {/* INDICATORS */}

              {columns.map((current, i) => {
                // const [indicator_impact, indicator_unit] = get_impact(current);
                const indicator_impact = get_impact_optimization(current, optimization_data).toFixed(2);
                // const indicator_unit = "mPt"
                const indicator_unit = impact_indicators.find((target) => target.id === current).ref_unit;
                const width = impact_indicators.find((target) => target.id === current).width;
                return (
                  <>
                    <div
                      key={"reducesubstepright" + `${current + i}`}
                      className={`flex justify-center items-center h-[40px]  w-[${width}px]  border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}
                    >
                      {indicator_impact} {" " + indicator_unit}
                    </div>
                  </>
                );
              })}

              <div
                key={"reducesubstepright" + Math.random() + "validate"}
                className={`flex justify-center items-center h-[40px]  w-[100px] border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}
              >
                <button>{checked ? <Checked height={30} /> : <Unchecked height={30} />}</button>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>

        {/* <p onClick={() => {
          console.log(quantity, quantityUnit)
        }}>
          DEBB
        </p> */}

        {/* OPTIMIAZTION_LINES */}
        {hidden[hiddenindex] ? null : (
          <>
            <div className="">
              <ReduceAnalysisLineRight
                key={"reducesubstepright_custom"}
                // width={width}
                checked={data.custom_analysis.checked}
                color={null}
                step={step}
                columns={columns}
                // icon={icon}
                // impact={(
                //   ((data.custom_analysis.flow.flow_impact_factors.find((i) => i.id === "da32f256-618d-4bec-a8d9-205817788b26").coefficient * data.custom_analysis.amount) / totalScore) *
                //   100
                // ).toFixed(2)}
                totalScore={totalScore}
                impact_factors={data.custom_analysis.flow.flow_impact_factors}
                item={data.custom_analysis.flow.name_fr}
                quantity={data.custom_analysis.amount}
                quantityUnit={data.custom_analysis.unit.name}
                conversion_factor={data.custom_analysis.unit.conversion_factor}
                flow_id={data.custom_analysis.id}
                line_index={line_index}
                changable={step <= 2 ? null : data.custom_analysis}
                ingredient_id={ingredient_id}
                is_reduce={true}
                impactt={impactt}
              />

              <ReduceAnalysisLineRight
                key={"reducesubstepright_opt"}
                // width={width}
                checked={data.custom_analysis.checked}
                color={"green"}
                step={step}
                columns={columns}
                // icon={icon}
                // impact={(
                //   ((data.optimization_results.flow.flow_impact_factors.find((i) => i.id === "da32f256-618d-4bec-a8d9-205817788b26").coefficient * data.optimization_results.amount) / totalScore) *
                //   100
                // ).toFixed(2)}
                totalScore={totalScore}
                impact_factors={data.optimization_results.flow.flow_impact_factors}
                item={data.optimization_results.flow.name_fr}
                quantity={data.optimization_results.amount}
                quantityUnit={data.optimization_results.unit.name}
                conversion_factor={data.optimization_results.unit.conversion_factor}
                flow_id={data.optimization_results.id}
                line_index={line_index}
                changable={step <= 2 ? null : data.optimization_results}
                ingredient_id={ingredient_id}
                is_reduce={true}
                impactt={impactt}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ReduceSubstepRight;
